<isophi-app-portfolio-plan-base-item #base *transloco="let t" [leftIcon]="'target'" [title]="t('plan/plannedActivities')" [allowEditMode]="allowEditMode">
  <div *ngIf="base.isViewMode() && form.controls.plannedActivities.value.length > 0" class="plan-items-wrap">
    <div class="plan-item" *ngFor="let plannedActivity of form.controls.plannedActivities.value">
      <span class="material-symbols-rounded"> arrow_forward </span>
      {{ plannedActivity }}
    </div>
  </div>
  <div *ngIf="allowEditMode && base.isEditMode()">
    <div class="add-plan-wrapper">
      <div class="input-group mb-2" *ngFor="let control of form.controls.plannedActivities.controls; let i = index">
        <input type="text" [formControl]="control" class="form-control" required />
        <div class="input-group-append">
          <span class="material-symbols-rounded close-icon pointer" (click)="removePlannedActivity(i)"> close </span>
        </div>
      </div>

      <button class="btn btn-icon mt-3" (click)="addPlannedActivity()">
        <span class="material-symbols-rounded text-primary fs-20"> add </span>
        {{ t('planDetail/addPlannedActivity') }}
      </button>
    </div>

    <div class="actions d-flex justify-content-end mt-4">
      <button (click)="cancel(); base.setMode(base.modeEnum.VIEW)" class="btn btn-light-outline">
        {{ t('common/cancel') }}
      </button>
      <button (click)="save(); base.setMode(base.modeEnum.VIEW)" class="btn btn-primary">
        {{ t('common/save') }}
      </button>
    </div>
  </div>
</isophi-app-portfolio-plan-base-item>
